function getTierCurrentMaxMintable(tierInfo, unixTimestamp = Math.floor(Date.now() / 1e3)) {
  return unixTimestamp < tierInfo.cutoffTime ? tierInfo.maxMintableUpper : tierInfo.maxMintableLower;
}

export { getTierCurrentMaxMintable };
